import {
  API_SET_CONTEXT_FILTER,
  API_SET_CONTEXT_LIST,
  API_REFRESH,
} from "../constants/actionTypes";

const initialState = {
  apiUrl: "",
  contextFilter: [],
  contextList: [],
  refresh: false,
};

function api(state = initialState, action) {
  switch (action.type) {
    case API_SET_CONTEXT_FILTER:
      return {
        ...state,
        contextFilter: action.filter,
      };

    case API_SET_CONTEXT_LIST:
      return {
        ...state,
        contextList: action.list,
      };

    case API_REFRESH:
      return {
        ...state,
        refresh: action.status,
      };

    default:
      return state;
  }
}

export default api;
